import * as React from 'react';
import type { ResultCounts } from '@chess/api-insights';
import { CardAside, CardEmpty } from '@chess/api-dashboard/react';
import { ResultDonut, StatTile, type FilterLink } from '@chess/api-insights/charts';
import './results.css';

export type ResultsCardProps = { link?: FilterLink } & (
  | { loading: true; games?: undefined; results?: undefined }
  | { loading?: false; games: number; results: ResultCounts }
);

/**
 * Games played in the last 30 days, and a donut of the results. The card
 * fills its row's height, the donut and legend centred under the count. While
 * `loading` (the store still reading the games), the card keeps its title
 * and labels and a skeleton stands in for each value from the data layer.
 * The body of the card: the section draws its frame and title
 * (`registerCard`, @chess/api-dashboard).
 */
export const ResultsCard: React.FC<ResultsCardProps> = (props) => (
  <>
    <CardAside>Last 30 days</CardAside>
    {props.loading ? (
      <>
        <StatTile loading unit="games" />
        <div className="results-card-body">
          <ResultDonut loading />
        </div>
      </>
    ) : (
      <>
        <StatTile value={props.games} unit={props.games === 1 ? 'game' : 'games'} />
        <div className="results-card-body">
          {props.games > 0 ? <ResultDonut results={props.results} link={props.link} /> : <CardEmpty>No games in the last 30 days.</CardEmpty>}
        </div>
      </>
    )}
  </>
);
